class TaskController implements ng.IComponentController {

    constructor(
    ) {
        'ngInject';
    }

}

export const taskComponent: ng.IComponentOptions = {
    controller: TaskController,
    template: <string>require('./task.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/tasks/task.component.ts